import React, {useCallback, useEffect, useState} from "react";
import {
    Dialog,
    DialogContent,
    Button,
    TextField,
    Box,
    Typography
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useAuth } from "../../../AuthContext/authContext";
import {GoogleSignInButton} from "../../atoms/GoogleSignInButton/GoogleSignInButton";

export const LoginDialog = (
    { isOpen, onClose }:
    {
        isOpen: boolean;
        onClose: (isClosed: boolean) => void
    }
) => {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const { login, loginError, resetLoginError } = useAuth();
    const theme = useTheme();

    useEffect(() => {
        if (!isOpen) {
            setPassword('');
            setEmail('');
            resetLoginError();
        }
    }, [isOpen, resetLoginError]);

    const handleSubmit = async () => {
        try {
            const loginResponse = await login(email, password);
            if(loginResponse) {
                onClose(true)
                resetLoginError()
            }
        } catch (err) {
            console.error("Login error:", err);
        }
    };

    const ErrorComponent = useCallback(() => {
        return loginError ? (
            <Typography
                variant="subtitle2"
                style={{ color: theme.palette.error.main, textAlign: 'center' }}
                mb={1}
            >
                {loginError.message}
            </Typography>
        ) : null;
    }, [loginError, theme.palette.error.main]);

    return (
        <Dialog
            open={isOpen}
            onClose={() => onClose(false)}
            style={{ padding: 0 }}
            aria-autocomplete="none"
        >
            <Typography variant="h6" component="p" mt={1.5} ml={'auto'} mr={'auto'}>
                Log in
            </Typography>
            <DialogContent
                aria-autocomplete="none"
                style={{
                    paddingTop: '4px',
                    paddingBottom: '8px',
                    width: '300px'
                }}
            >
                <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="space-between"
                >
                    {ErrorComponent()}
                    <TextField
                        label="email address"
                        type="email"
                        variant="outlined"
                        style={{ marginTop: '4px' }}
                        onChange={
                            (e) => setEmail(e.target.value)
                        }
                        value={email}
                    />
                    <TextField
                        style={{ marginTop: '12px' }}
                        label="password"
                        type="password"
                        variant="outlined"
                        onChange={
                            (e) => setPassword(e.target.value)
                        }
                        value={password}
                    />
                    <Button
                        style={{ marginTop: '12px', marginBottom: '12px', textTransform: 'none' }}
                        variant="contained"
                        onClick={handleSubmit}
                    >
                        Submit
                    </Button>
                    <GoogleSignInButton onClose={onClose}/>
                </Box>
            </DialogContent>
        </Dialog>
    );
};
